var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.589,
    height: 15.419,
    viewBox: "0 0 16.589 15.419",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M146.358,161.229a2.819,2.819,0,0,0-1.052.28,2.9,2.9,0,0,0-1.386,1.5,32.635,32.635,0,0,0-.889,4.572c-.321,1.853-.632,3.621-.691,3.928a4.788,4.788,0,0,0-.107,1.631,3.379,3.379,0,0,0,2.48,2.951l.335.1h10.518l.4-.1a3.209,3.209,0,0,0,2.148-1.677,3,3,0,0,0,.379-1.42,5.9,5.9,0,0,0-.156-1.545c-.412-2.43-1.341-7.692-1.42-8.042a2.54,2.54,0,0,0-.749-1.343,2.1,2.1,0,0,0-.71-.521,2.94,2.94,0,0,0-1.35-.313c-.667-.046-7.288-.044-7.751,0m-.071,1.032a1.864,1.864,0,0,0-1.474,1.145,11.354,11.354,0,0,0-.258,1.234c-.19,1.132-.963,5.492-1.162,6.547a6.6,6.6,0,0,0-.109,2.246,2.218,2.218,0,0,0,1.84,1.7c.254.035,1.79.046,5.441.037l5.087-.013.279-.1a2.385,2.385,0,0,0,1.309-1.122,2.839,2.839,0,0,0,.135-2c-.162-.828-.442-2.457-.566-3.3-.06-.406-.235-1.4-.389-2.22s-.337-1.79-.407-2.168c-.221-1.187-.514-1.6-1.351-1.921l-.254-.1-3.95-.007c-2.172,0-4.049.01-4.171.031m1.115,1.154a.6.6,0,0,0-.186.175,4.645,4.645,0,0,0-.052.957,3.415,3.415,0,0,0,.337,1.916,3.338,3.338,0,0,0,1.862,1.607,3.1,3.1,0,0,0,2.949-.475,3.374,3.374,0,0,0,1-1.282,3.526,3.526,0,0,0,.284-1.629c.025-.9,0-1.063-.216-1.2a.561.561,0,0,0-.75.18,6.375,6.375,0,0,0-.065.936,3.425,3.425,0,0,1-.1,1.061,2.243,2.243,0,0,1-2.137,1.537,2.146,2.146,0,0,1-2.1-1.612,4.563,4.563,0,0,1-.066-1.017c0-.863-.033-1.006-.266-1.148a.418.418,0,0,0-.493,0",
    transform: "translate(-142.058 -160.92)",
    fill: "#1b2737",
    stroke: "#1b2737",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.7c9d6f56bfaefd9f7098eedb66f4da87.svg";
export { ForwardRef as ReactComponent };